module.exports = __webpack_public_path__ + "static/media/professional-active.416628fc.svg";